import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { MAPPINGS_MODE } from '../../common/BaseInput/BaseInput.constants';
import { BaseInputRoot } from '../../common/BaseInput/BaseInput.styled';
// styled-components.
// -----------------------------------------------------------------------------
export const InputNumberAdormentRoot = styled.div `
  ${({ position, type }) => css `
    /* Display & Box */
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 46px;
    color: ${tokens.colors.green[700].value};

    ${position === 'end' && `right: 30px;`}

    ${type === 'euro' && ` color: ${tokens.colors.green[700].value};`}
  `}
`;
export const InputNumberButtons = styled.div `
  ${({ mode, size }) => css `
    /* Display & Box Model */
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-evenly;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;

    > button {
      /* Display & Box Model */
      border: 2px solid ${MAPPINGS_MODE[mode].border};
      border-bottom: 0;
      border-right: 0;
      border-radius: 0;
      border-top: 0;
      margin: 0;
      padding: ${size === 'xs' ? 0 : getSpace('xs')} ${getSpace('s')};
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50%;

      /* Color */
      appearance: none;
      background-color: transparent;

      /* Text */
      font: inherit;
      text-align: inherit;

      /* Miscellanea */
      cursor: pointer;
      transition: 0.3s;
    }

    > button:first-of-type {
      border-bottom: 1px solid ${MAPPINGS_MODE[mode].border};

      &:hover,
      &:focus {
        border-radius: 0 10px 0 0;
      }

      svg {
        margin-bottom: -3px;
      }
    }

    > button:last-of-type {
      border-top: 1px solid ${MAPPINGS_MODE[mode].border};

      &:hover,
      &:focus {
        border-radius: 0 0 10px 0;
      }
    }

    > button:hover,
    > button:focus {
      background-color: ${tokens.colors.midnight[850].value};
      color: ${tokens.colors.white[100].value};
    }

    &.error {
      > button {
        border-color: ${tokens.colors.red[700].value};
      }

      > button:first-of-type,
      > button:last-of-type {
        border-color: ${tokens.colors.red[700].value};
      }
    }
  `}
`;
export const InputNumberRoot = styled.input `
  ${({ hasEndAdorment, hasStartAdorment }) => css `
    ${BaseInputRoot}

    /* Miscellanea */
    appearance: textfield;

    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }

    ${hasStartAdorment && `padding-left: 46px;`}
    ${hasEndAdorment && `padding-right: 46px;`}
  `}

  &.error {
    background: none;
  }
`;
export const InputButtonWrapper = styled.div `
  ${({ inputWidth, mode }) => css `
    /* Display & Box Model */
    position: relative;
    width: ${inputWidth};

    :hover {
      button {
        border-color: ${MAPPINGS_MODE[mode].hover.border};
      }

      ${InputNumberRoot} {
        border-color: ${MAPPINGS_MODE[mode].hover.border};

        &.error {
          border-color: ${tokens.colors.red[700].value};
        }
      }
    }

    :focus-within {
      button {
        border-color: ${MAPPINGS_MODE[mode].focus.border};
      }

      ${InputNumberRoot} {
        border-color: ${MAPPINGS_MODE[mode].focus.border};

        &.error {
          border-color: ${tokens.colors.red[700].value};
        }
      }
    }
  `}
`;
//# sourceMappingURL=InputNumber.styles.js.map